module.exports = __webpack_public_path__ + "img/2.a76af26d.webp";